import React, { useContext, useEffect, useState } from 'react';
import { ProfileContext } from '../../../context/ProfileContext';
import StyledButton from '../../../components/Button/Button';
import { useNavigate } from 'react-router-dom';
import StyledBgContainer from '../../../components/StyledBgContainer/StyledBgContainer';
import TopNav from '../../../components/TopNav/TopNav';
import { Typography, Box, Container } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { editProfile } from '../../../services/NetworkServices';
import ApiStatus from '../../../config/apiStatusConstants';
import './BabysitterChangeProfilePic.css';

const BabysitterChangeProfilePic: React.FC = () => {
  const context = useContext(ProfileContext);
  if (!context) {
    throw new Error('ProfileContext must be used within a ProfileProvider');
  }

  const {
    profilePicPreview,
    handleProfilePicChanged,
    tempProfilePic,
    handleProfilePic,
  } = context;

  const navigate = useNavigate();
  const [apiStatus, setApiStatus] = useState<ApiStatus>(ApiStatus.INITIAL);
  const [errorMsg, setErrorMsg] = useState<string>('');

  useEffect(() => {
    if (!profilePicPreview) {
      navigate('/supervisor/edit-profile');
    }
  }, [profilePicPreview, navigate]);

  const handleUpload = async () => {
    if (!tempProfilePic) {
      navigate(-1);
      return;
    }
    try {
      setApiStatus(ApiStatus.LOADING);
      const updatedData = new FormData();
      updatedData.append('profilePic', tempProfilePic);
      const response = await editProfile(updatedData);
      if (response.data) {
        handleProfilePicChanged();
        handleProfilePic(tempProfilePic);
        setApiStatus(ApiStatus.SUCCESS);
        navigate(-1);
      }
    } catch (error: any) {
      setApiStatus(ApiStatus.FAILURE);
      setErrorMsg(
        error?.response?.data?.error?.message || 'Failed to update profile picture',
      );
    }
  };

  return (
    <StyledBgContainer>
      <TopNav showArrow={true} />
      <Container maxWidth="sm">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: 'white',
              fontFamily: 'Opensans',
              fontWeight: '700',
            }}
          >
            Change Profile Picture
          </Typography>
          <Typography variant="body2" sx={{ color: 'grey', mt: 1, mb: 3 }}>
            Upload a new picture to be used along side your name to identify you
            as the user
          </Typography>

          <Box
            className="new-profile"
            sx={{
              width: '220px',
              height: '220px',
              overflow: 'hidden',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              src={profilePicPreview || ''}
              alt="Profile Preview"
              style={{
                width: '85%', // Make it fit the width of the box
                height: '85%', // Make it fit the height of the box
                objectFit: 'cover',
                borderRadius: '19px',
              }}
            />
          </Box>

          {apiStatus === ApiStatus.LOADING ? (
            <StyledButton sx={{ marginTop: '13vh' }}>
              <CircularProgress size={24} />
            </StyledButton>
          ) : (
            <StyledButton onClick={handleUpload} sx={{ marginTop: '13vh' }}>
              Upload New
            </StyledButton>
          )}
          {apiStatus === ApiStatus.FAILURE && (
            <p style={{ color: 'white' }}>{errorMsg}</p>
          )}
        </Box>
      </Container>
    </StyledBgContainer>
  );
};

export default BabysitterChangeProfilePic;
